import { put, call } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import {
  sendVehiclesFgisTaxiFailed,
  sendVehiclesFgisTaxiSuccessful,
} from '../actions';
import { uploadFile } from '../../System/actions';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import processError from '../../../utils/processError';
import sign from '../../System/sagas/sign';
import { nameBySave } from '../../../utils/utils';

export default function* sendVehiclesFgisTaxi(action) {
  try {
    const {
      payload: {
        cert,
      } = {},
    } = action;
    const url = `${BACKEND_URL}/registries/vehicles/fgis-taxi`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    /*
    if (dataResponse.status !== OK) {
      throw new Error('Ошибка на сервере');
    }
    const data = yield dataResponse.blob();
    if (!data) {
      throw new Error('Ошибка: не найден фаил для подписи');
    }
    const signature = yield sign(cert, data, true);
    if (typeof signature === 'string') {
      throw new Error(signature);
    }
    const fileFormData = new FormData();
    const sigFormData = new FormData();
    const name = 'test.xml';
    fileFormData.append('model_type', 'document');
    fileFormData.append('model_id', document.id);
    fileFormData.append('collection_name', 'signed');
    fileFormData.append('name', name);
    fileFormData.append('file', data, nameBySave(name));

    sigFormData.append('model_type', 'document');
    sigFormData.append('model_id', document.id);
    sigFormData.append('collection_name', 'signature');
    sigFormData.append('name', `${name}.sig`);
    sigFormData.append('file', signature, nameBySave(`${name}.sig`));

    const fileUploadPromise = yield put(uploadFile(fileFormData));
    const fileUpload = yield fileUploadPromise;

    const signatureUploadPromise = yield put(uploadFile(sigFormData));
    const signatureUpload = yield signatureUploadPromise;
    if (!fileUpload || !signatureUpload) {
      throw new Error(`Фаил ${name}.sig не сохранен`);
    }
    */
    yield put(sendVehiclesFgisTaxiSuccessful());
    yield call(resolveActionPromise(action, {}));
  } catch (e) {
    yield put(sendVehiclesFgisTaxiFailed([]));
    yield call(rejectActionPromise(action, {}));
    yield processError(e);
  }
}
